module.exports = __webpack_public_path__ + "static/media/antigua-historic-10.41e6aa48.jpg";